// Equipe (hierarquia analista → gestor) — ver docs/API.md do marketingbackgo, seção "Equipe".

export type TeamPosition = 'analyst' | 'manager';

export interface AuditFields {
  created_at: string;
  created_by: string;
  updated_at?: string;
  last_updated_by?: string;
}

export interface TeamMember extends AuditFields {
  id: number;
  name: string;
  email: string;
  position: TeamPosition;
  manager_member_id?: number;
  manager_name?: string;
  is_active: boolean;
}

export interface TeamMemberNode extends TeamMember {
  subordinates: TeamMemberNode[];
}

export interface TeamMemberFormData {
  name: string;
  email: string;
  position: TeamPosition;
  manager_member_id?: number | null;
  is_active?: boolean;
}

/** UserInfo devolvido por /auth/me (e dentro de MyProfile.user). */
export interface ApiUserInfo {
  oid: string;
  email: string;
  name: string;
  given_name: string;
  family_name: string;
  tid: string;
  roles: string[];
}

/** GET /auth/profile — o que a tela precisa saber do usuário logado. */
export interface MyProfile {
  user: ApiUserInfo | null;
  is_admin: boolean;
  member?: TeamMember;
  /** Vem da hierarquia do cadastro (tem subordinados), não da role. */
  is_manager: boolean;
  subordinates: TeamMember[];
  subordinate_ids: number[];
}

export const POSITION_LABELS: Record<TeamPosition, string> = {
  analyst: 'Analista',
  manager: 'Gestor',
};
